import Vue from 'vue';
import axios from 'axios';
import route from '@H/route';
import router from '@R';
import { getErrorFromResponse } from '@H/error-codes';

export default {
    getUser(ctx) {
        const url = route('widget.get-user');

        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.post(url);

                // Check if user is present in the response ..
                // Otherwise we need to display an error screen as the widget cannot do anything without this.
                if (typeof res.data.user == 'undefined') {
                    reject(ctx.dispatch('widgetError'));
                }

                ctx.commit('setUser', res.data.user);
                if (res.data.user.language !== '') {
                    ctx.dispatch('setLanguage', res.data.user.language);
                }

                // Host is unreliable when in SC2 as they will always call the main url
                // Get the instance from the user if possible.
                window.isSmartCharts = res.data.user.instance === 'App\\Instances\\SmartCharts';

                resolve(res.data.user);
            } catch (err) {
                ctx.dispatch('widgetError');
                reject(err);
            }
        });
    },
    getSubscriptions(ctx) {
        const url = route('widget.get-subscriptions');

        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.post(url);
                const subscriptions = res.data;
                // const all_products = res.data.all_products;

                ctx.commit('setSubscriptions', subscriptions);

                resolve(subscriptions);
            } catch (err) {
                ctx.dispatch('widgetError');
                reject(err);
            }
        });
    },
    getPaymentAttempts(ctx) {
        const url = route('widget.payment-attempts');

        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.post(url);

                ctx.commit('setPaymentAttempts', res.data);
                resolve(res.data);
            } catch (err) {
                ctx.dispatch('widgetError');
                reject(err);
            }
        });
    },
    async updateProfileMinimum(ctx) {
        const url = route('widget.update-profile')


        try {
            let theme = ''

            if(ctx.state.user.theme === '0' || ctx.state.user.theme === 0) {
                theme = 'Light Theme'
            } else {
                theme = 'Dark Theme'
            }

            const res = await axios.post(url, {
                language: ctx.state.user.language,
                nickname: ctx.state.user.nickname,
                sc2_theme: ctx.state.user.theme,
            });

            ctx.commit('setFormSubmitting', false, { root: true });

            if (res.data.success) {
                // Close the widget instance and pass the updated user to the parent.
                return ctx.state._widgetInstance.SendDialogResult(
                    new SC.Error({
                        code: SC.errors.ErrorCodes.NOERROR,
                        myResultData: {
                            user: { ...ctx.state.user, region: res.data.region }
                        }
                    })
                );
            }

            return ctx.dispatch('widgetError');
        } catch (err) {
            ctx.dispatch(
                'Flash/setFlash',
                { message: getErrorFromResponse(err) },
                { root: true }
            );
            ctx.commit('setFormSubmitting', false, { root: true });
        }
    },
    async updateProfile(ctx) {
        const url = route('widget.update-profile');

        try {
            const res = await axios.post(url, {
                salutation: ctx.state.user.salutation,
                first_name: ctx.state.user.first_name,
                last_name: ctx.state.user.last_name,
                experience: ctx.state.user.experience,
                date_of_birth: ctx.state.user.date_of_birth,
                language: ctx.state.user.language,
                theme: ctx.state.user.theme,
                nickname: ctx.state.user.nickname,
                email: ctx.state.user.email,
                mobile: ctx.state.user.mobile,
                home_country: ctx.state.user.home_country,
                home_state: ctx.state.user.home_state,
                home_house_name: ctx.state.user.home_house_name,
                home_house_number: ctx.state.user.home_house_number,
                home_street: ctx.state.user.home_street,
                home_city: ctx.state.user.home_city,
                home_postcode: ctx.state.user.home_postcode
            });

            ctx.commit('setFormSubmitting', false, { root: true });

            if (res.data.success) {
                // Close the widget instance and pass the updated user to the parent.
                return ctx.state._widgetInstance.SendDialogResult(
                    new SC.Error({
                        code: SC.errors.ErrorCodes.NOERROR,
                        myResultData: {
                            user: { ...ctx.state.user, region: res.data.region }
                        }
                    })
                );
            }

            return ctx.dispatch('widgetError');
        } catch (err) {
            ctx.dispatch(
                'Flash/setFlash',
                { message: getErrorFromResponse(err) },
                { root: true }
            );
            ctx.commit('setFormSubmitting', false, { root: true });
        }
    },
    async updatePersonalisation(ctx) {
        const url = route('widget.personalise');

        try {
            await axios.post(url, {
                nickname: ctx.state.user.nickname
            });

            ctx.commit('setFormSubmitting', false, { root: true });
        } catch (err) {
            ctx.dispatch(
                'Flash/setFlash',
                { message: getErrorFromResponse(err) },
                { root: true }
            );
            ctx.commit('setFormSubmitting', false, { root: true });
        }
    },
    async resetPassword(ctx) {
        const url = route('widget.reset-password');
        const {
            password,
            current_password,
            password_confirmation
        } = ctx.rootState.Auth;

        try {
            await axios.post(url, {
                current_password,
                password,
                password_confirmation
            });

            ctx.commit('setFormSubmitting', false, { root: true });

            // Close the widget instance
            return ctx.state._widgetInstance.SendDialogResult(
                new SC.Error({
                    code: SC.errors.ErrorCodes.NOERROR,
                    myResultData: {}
                })
            );
        } catch (err) {
            window.anError = err.response;
            ctx.dispatch(
                'Flash/setFlash',
                { message: getErrorFromResponse(err, err.message) },
                { root: true }
            );
            ctx.commit('setFormSubmitting', false, { root: true });
        }
    },
    widgetError() {
        return router.push({ name: 'widget-error' });
    },
    resetHomeFields(ctx) {
        ctx.commit('clearHomeAddressFields');
    },
    setLanguage(ctx, langCode) {
        // Check it's a valid language code, i.e. must exist in availableLanguages.js
        if (typeof this._vm.$codes[langCode] == 'undefined') return;

        ctx.commit('setLanguage', langCode);

        // Gettext vue plugin requires localized iso code: en_GB, fr_FR etc.
        this._vm.$language.current = `${langCode}_${
            this._vm.$codes[langCode].code
        }`;
    },
    setTheme(ctx, payload) {
        // Check it's a valid language code, i.e. must exist in availableLanguages.js
        // if (typeof this._vm.$codes[themeCode] == 'undefined') return;
        // let theme = ''
        // if(payload === '0' || payload === 0) {
        //     theme = 'Light Theme'
        // } else {
        //     theme = 'Dark Theme'
        // }

        // Gettext vue plugin requires localized iso code: en_GB, fr_FR etc.
        // this._vm.theme.current = `${themeCode}_${
        //     this._vm.$codes[themeCode].code
        // }`;
        ctx.commit('setTheme', payload);
    },
    resetBillingFields(ctx) {
        ctx.commit('clearBillingAddressFields');
    },

    setField(ctx, payload) {
        ctx.commit(payload.identifier, payload.data);
    },

    setBillingFields(ctx, payload) {
        ctx.commit('setBillingFields', payload);
    },

    async initiateSubscriptionUpgrade(ctx) {
        ctx.commit('setFormSubmitting', true, { root: true });

        try {
            await axios.post(route('widget.upgrade-subscription'), ctx.rootState.Widget.user);

            ctx.commit('setFormSubmitting', false, { root: true });

            // Redirect to the view that loads in the trustpay iframe
            return router.push({ name: 'widget-upgrade-subscription-payment' });
        } catch (err) {
            window.anError = err.response;
            ctx.dispatch(
                'Flash/setFlash',
                { message: getErrorFromResponse(err, err.message) },
                { root: true }
            );
            ctx.commit('setFormSubmitting', false, { root: true });
        }
    },

    async cancelSubscriptions(ctx) {
        ctx.commit('setFormSubmitting', true, { root: true });

        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.post(route('widget.cancel-subscription'), { subscriptions: ctx.rootState.Widget.cancelSubscriptionsCheckboxes });

                ctx.commit('setFormSubmitting', false, { root: true });

                resolve(res);
            } catch (err) {
                window.anError = err.response;
                ctx.dispatch(
                    'Flash/setFlash',
                    { message: getErrorFromResponse(err, err.message) },
                    { root: true }
                );
                ctx.commit('setFormSubmitting', false, { root: true });

                reject(err);
            }
        });
    },

    /**
     *
     * @param {Object} ctx - Context set by vuex (store)
     */
    async loadPaymentConfirmation(ctx) {
        const { $gettext } = this._vm;
        const params = {
            subscriptionUpgradeId: ctx.state.subscriptionUpgradeId
        };

        try {
            const res = await axios.get(route('widget.payment-confirmation'), { params })

            ctx.commit('payment', res.data.payment);

            return res.data.payment;
        } catch (err) {
            ctx.dispatch(
                'Flash/setFlash',
                $gettext('There was a problem loading payment data.'),
                { root: true }
            );

            throw new Error(err);
        }
    },

    async sendTeaserEmail(ctx) {
        const { $gettext } = this._vm;

        // Grab the full subscription and purchase option objects by using the selectedUpgrade to filter the full arrays down to just one:
        const subscription = ctx.state.subscriptions.find(subscription => subscription.subscriptionId == ctx.state.selectedUpgrade.subscriptionId),
            purchaseOption = subscription.pricing.find(pricing => pricing.Id == ctx.state.selectedUpgrade.pricingOption.id);

        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.post(route('widget.subscription-teaser-email'), {
                    subscription: subscription,
                    purchaseOption: purchaseOption
                })

                resolve(res.data);
            } catch (err) {
                ctx.dispatch(
                    'Flash/setFlash',
                    $gettext('There was a problem loading payment data.'),
                    { root: true }
                );

                reject(err);
            }
        });
    },

    async sendConfirmationEmail(ctx) {
        const { $gettext } = this._vm;

        // Grab the full subscription and purchase option objects by using the selectedUpgrade to filter the full arrays down to just one:
        const subscription = ctx.state.subscriptions.find(subscription => subscription.subscriptionId == ctx.state.selectedUpgrade.subscriptionId),
            purchaseOption = subscription.pricing.find(pricing => pricing.Id == ctx.state.selectedUpgrade.pricingOption.id);

        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.post(route('widget.subscription-confirmation-email'), {
                    subscription: subscription,
                    purchaseOption: purchaseOption
                })

                resolve(res.data);
            } catch (err) {
                ctx.dispatch(
                    'Flash/setFlash',
                    $gettext('There was a problem loading payment data.'),
                    { root: true }
                );

                reject(err);
            }
        });
    },

    async sendCancellationEmail(ctx, subscriptions) {
        const { $gettext } = this._vm;

        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.post(route('widget.subscription-cancellation-email'), {
                    subscriptions: subscriptions,
                })

                resolve(res.data);
            } catch (err) {
                ctx.dispatch(
                    'Flash/setFlash',
                    $gettext('There was a problem loading payment data.'),
                    { root: true }
                );

                reject(err);
            }
        });
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Widget/actions.js